// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const WAREHOUSE_SQL_DATASET_STEP_SHAPES = [
  {
    stepType: PipelineStepType.WAREHOUSE_SQL_DATASET,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      Dataset: {
        systemName: 'Dataset',
        displayName: 'Dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      dataFrameName: {
        kind: 'string',
        required: true
      },
      parameterizedSQLQuery: {
        kind: 'string',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
